import posNotificationInstance from '../instance'

const getWatches = () => {
	return posNotificationInstance.get('watches')
}

export default getWatches
